import { render, staticRenderFns } from "./ChatSide.vue?vue&type=template&id=1201bbf8&scoped=true&"
import script from "./ChatSide.vue?vue&type=script&lang=js&"
export * from "./ChatSide.vue?vue&type=script&lang=js&"
import style0 from "./ChatSide.vue?vue&type=style&index=0&id=1201bbf8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1201bbf8",
  null
  
)

export default component.exports